// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n2fR","buttons":"styles_buttons__1PoxW"};